export const PRICE_ASC = 'price_asc';
export const PRICE_DESC = 'price_desc';
export const NEW_FIRST = 'new_first';
export const NEW_LAST = 'new_last';
export const ASSIGNED_DEPOSITE_DATE_ASC = 'assigned_deposite_date_asc';
export const ASSIGNED_DEPOSITE_DATE_DESC = 'assigned_deposite_date_desc';
